import React from "react";
import PageWrapper from "../components/PageWrapper";
import { motion } from "framer-motion";

export default function About() {
  return (
    <PageWrapper>
      
      {/* HERO SECTION */}
      <section className="bg-gradient-to-br from-blue-700 via-purple-700 to-indigo-700 text-white pt-24 pb-20">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-6xl font-extrabold">
            About <span className="text-yellow-300">Navith Pvt Ltd</span>
          </h1>
          <p className="text-lg md:text-xl mt-4 max-w-3xl mx-auto opacity-90">
            Empowering human potential with dignified innovation.  
            Building next-generation educational and AI-powered platforms.
          </p>
        </div>
      </section>

      {/* COMPANY INTRO */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
          
          {/* LEFT */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.7 }}
          >
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 leading-tight">
              Empowering Schools Through  
              <span className="text-blue-600"> Smart Technology & AI</span>
            </h2>

            <p className="mt-4 text-gray-600 leading-relaxed">
              Navith Pvt Ltd is a growing technology company focused on  
              Educational Technology, Quality Management Systems, School  
              Management Systems, and AI-driven platforms.
            </p>

            <p className="mt-3 text-gray-600 leading-relaxed">
              Headquartered in Kilakarai, we create transformative tools  
              that unlock human potential, bring efficiency, and elevate  
              educational institutions across India.
            </p>
          </motion.div>

          {/* RIGHT — Animated Card */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.7 }}
          >
            <div className="rounded-2xl shadow-2xl bg-gradient-to-br from-blue-600 to-purple-600 text-white p-10">
              <h3 className="text-2xl font-bold mb-3">What We Stand For</h3>
              <p className="opacity-90">
                Service, excellence, innovation, compassion, and wisdom  
                form the core of every solution we create.
              </p>
            </div>
          </motion.div>

        </div>
      </section>

      {/* MISSION & VISION */}
      <section className="py-20 bg-gradient-to-t from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h2 className="text-4xl font-extrabold text-gray-800">
            Our Mission & Vision
          </h2>
          <p className="mt-4 text-gray-600 max-w-3xl mx-auto">
            Guided by divine wisdom and grounded in service, excellence,  
            and compassion, we empower individuals and institutions with  
            tools that transform education and unlock human dignity.
          </p>

          <div className="grid md:grid-cols-2 gap-10 mt-12">

            <AboutCard 
              title="Our Mission" 
              text="To empower institutions with future-ready tools that simplify management, 
              enhance learning experiences, and create meaningful impact across communities." 
              icon="🚀"
            />

            <AboutCard 
              title="Our Vision" 
              text="To explore new horizons and bring transformative innovation to education, 
              ensuring schools evolve into smart, efficient, and student-centered environments." 
              icon="🌍"
            />

          </div>
        </div>
      </section>

      {/* CORE VALUES */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 text-center">
          
          <h2 className="text-4xl font-extrabold text-gray-800">
            Our Core Values
          </h2>

          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 mt-12">
            
            <ValueCard title="Service" icon="❤️" text="Serving with humility and compassion." />
            <ValueCard title="Excellence" icon="⭐" text="Pursuing perfection in every step." />
            <ValueCard title="Innovation" icon="💡" text="Solving problems with creativity." />
            <ValueCard title="Compassion" icon="🤝" text="Empathy fuels our decisions." />
            <ValueCard title="Wisdom" icon="🧠" text="Values that guide our journey." />
            <ValueCard title="Integrity" icon="🛡️" text="Honesty in every work we deliver." />

          </div>
        </div>
      </section>

    </PageWrapper>
  );
}

function AboutCard({ title, text, icon }) {
  return (
    <motion.div
      whileHover={{ scale: 1.05 }}
      className="p-8 rounded-2xl shadow-xl bg-white border border-gray-100"
    >
      <div className="text-5xl mb-4">{icon}</div>
      <h3 className="text-xl font-bold text-gray-800">{title}</h3>
      <p className="text-gray-600 mt-2">{text}</p>
    </motion.div>
  );
}

function ValueCard({ title, icon, text }) {
  return (
    <motion.div
      whileHover={{ scale: 1.05 }}
      className="p-6 rounded-xl shadow-lg bg-gray-50 border border-gray-100"
    >
      <div className="text-4xl mb-3">{icon}</div>
      <h4 className="text-lg font-bold text-gray-800">{title}</h4>
      <p className="text-gray-600 mt-1 text-sm">{text}</p>
    </motion.div>
  );
}